export const componentStyles = (theme) => ({
    textFields: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: "#f9fafb", 
            borderRadius: "12px", 
            paddingLeft: "8px", 
            
            "& fieldset": {
                border: `1px solid #e5e7eb`,
            },
            "&:hover fieldset": {
                border: "1px solid #aaa",
            },
            "&.Mui-focused fieldset": {
                border: `1px solid ${theme.palette.primary.main}`, 
            },
        },

        // Placeholder styles
        "& .MuiInputBase-input::placeholder": {
            color: "#888",
            opacity: 1, 
            paddingLeft: "0.6rem",
        },
    },
});

export const compoentStyles = (theme) => ({
    heading: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        fontSize: '1.3rem'
    },
})